import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PageWrapper from '../../components/PageWrapper';
import AnimatedSection from '../../components/AnimatedSection';
import {
  FiMapPin, FiPhone, FiMail, FiClock, FiSend,
  FiMessageCircle, FiUser, FiPhoneCall
} from 'react-icons/fi';
import './Contact.css';
import MapComponent from '../../components/MapComponent.jsx';
import { addForm } from '../../api/gwform.js';
import { message } from 'antd';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    remark: '',
    email: '',
    content: '',
    source: '识道造价',
  });

  // 容器动画 variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    // 这里可以添加表单提交逻辑
    await addForm(formData);
    message.success('感谢您的咨询，我们会尽快与您联系！')
    setFormData({ name: '', phone: '', remark: '', content: '', email: '', source: '识道造价' });
  }

  const contactInfo = [
    {
      icon: <FiMapPin />,
      title: '公司地址',
      content: '宁波市高新区创苑路750号软件园D座8F',
      subContent: '欢迎实地拜访'
    },
    {
      icon: <FiPhone />,
      title: '联系电话',
      content: '139-5780-8808',
      subContent: '工作日 9:00-18:00'
    },
    {
      icon: <FiMail />,
      title: '电子邮箱',
      content: 'shidao@yuezhong.com',
      subContent: '24小时内回复'
    },
    {
      icon: <FiClock />,
      title: '服务时间',
      content: '周一至周五',
      subContent: '9:00-18:00'
    }
  ];

  const serviceTypes = [
    { value: 'cost', label: '工程造价咨询' },
    { value: 'budget', label: '概预算结算审核' },
    { value: 'tendering', label: '招投标服务' },
    { value: 'platform', label: '数智平台咨询' },
    { value: 'other', label: '其他咨询' }
  ];

  return (
    <PageWrapper className="contact-page">
      <AnimatedSection className="contact-hero">
        <div className="container">
          <motion.h1 className="con_black" variants={itemVariants}>联系我们</motion.h1>
          <motion.p className="con_black" variants={itemVariants}>专业团队随时为您服务</motion.p>
        </div>
      </AnimatedSection>

      <AnimatedSection className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <motion.div
              className="contact-info-section"
              variants={itemVariants}
            >
              <h2>联系方式</h2>
              <p className="section-desc">多种方式联系我们，我们会在第一时间回复您</p>

              <div className="contact-cards">
                {contactInfo.map((item, index) => (
                  <motion.div
                    key={index}
                    className="contact-card"
                    variants={cardVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    whileHover={{ y: -5 }}
                  >
                    <div className="contact-icon">{item.icon}</div>
                    <h3>{item.title}</h3>
                    <p className="contact-main">{item.content}</p>
                    <p className="contact-sub">{item.subContent}</p>
                  </motion.div>
                ))}
              </div>

              <motion.div
                className="quick-contact"
                variants={itemVariants}
              >
                <h3>快速联系</h3>
                <div className="quick-buttons">
                  <motion.a
                    href="tel:"
                    className="quick-btn phone"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <FiPhoneCall />
                    <span>一键拨号</span>
                  </motion.a>
                  <motion.a
                    href="mailto:"
                    className="quick-btn email"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <FiMail />
                    <span>发送邮件</span>
                  </motion.a>
                  <motion.button
                    className="quick-btn chat"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <FiMessageCircle />
                    <span>在线咨询</span>
                  </motion.button>
                </div>
              </motion.div>

              <motion.div
                className="map-placeholder"
                style={{ padding: 0, height: '270px', overflow: 'hidden' }}
                variants={itemVariants}
              >
                <MapComponent />
              </motion.div>
            </motion.div>

            <motion.div
              className="contact-form-section"
              variants={itemVariants}
            >
              <h2>在线咨询</h2>
              <p className="section-desc">填写表单，我们会在30分钟内与您联系</p>

              <motion.form
                className="contact-form"
                onSubmit={handleSubmit}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
              >
                <motion.div
                  className="form-group"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                >
                  <label>
                    <FiUser />
                    您的姓名 <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="请输入您的姓名"
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                >
                  <label>
                    <FiPhone />
                    联系电话 <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder="请输入您的联系电话"
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                >
                  <label>
                    <FiMail />
                    电子邮箱
                  </label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder="请输入您的邮箱（选填）"
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 }}
                >
                  <label>
                    <FiMessageCircle />
                    咨询类型 <span className="required">*</span>
                  </label>
                  <select
                    required
                    value={formData.remark}
                    onChange={(e) => setFormData({ ...formData, remark: e.target.value })}
                  >
                    <option value="">请选择咨询类型</option>
                    {serviceTypes.map((type) => (
                      <option key={type.value} value={type.label}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.7 }}
                >
                  <label>
                    <FiMessageCircle />
                    详细需求
                  </label>
                  <textarea
                    rows="5"
                    value={formData.content}
                    onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                    placeholder="请简要描述您的需求，我们会根据您的需求提供专业建议"
                  ></textarea>
                </motion.div>

                <motion.button
                  type="submit"
                  className="submit-btncon"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <FiSend />
                  提交咨询
                </motion.button>

                <p className="form-note">
                  提交后，我们的专业顾问会在30分钟内与您联系
                </p>
              </motion.form>
            </motion.div>
          </div>
        </div>
      </AnimatedSection>
    </PageWrapper>
  );
};

export default Contact;